import { TrackingOptions } from "~/types/trackings.models";

import { ClientUtils } from "./client-utils";

declare const window: Window & { dataLayer: any[] };

export default class TrackingUtils {
  static mapTrackEditorialPage(
    props: Record<string, any>
  ): Record<string, any> {
    const title = props.page.seoMetadata?.fields.seoTitle;
    const slugs = props.page.slug.split("/");
    const extension =
      slugs && slugs.length
        ? {
            page_type_section: "editorial-" + slugs[slugs.length - 1],
          }
        : {};
    return { title, extension };
  }

  /**
   * Formats a boolean as a string, as requested for trackings
   * @param {boolean} value Boolean valie to format
   * @param {boolean }asLetter Formats given value in Y or N format
   * @returns The formatted value
   */
  static formatBoolean(value: boolean, asLetter?: boolean): string {
    if (asLetter) {
      return value ? "Y" : "N";
    }
    return String(value);
  }

  /**
   * Push given object in datalayer
   * @param payload object with tracking data
   * @param options tracking options
   */
  static track(payload: Record<string, any>, options?: TrackingOptions) {
    // console.log("Tracking ", payload);
    if (typeof window !== "undefined" && window.dataLayer) {
      if (options?.ga4 || payload.ecommerce) {
        window.dataLayer.push({ ecommerce: null });
      }
      window.dataLayer.push(payload);
      this._saveLastStatus(payload);
    }
  }

  /**
   * Saves datalayer payload in a global object (used by third parties to retrieve tracking data)
   * @param payload Datalayer payload to reference
   */
  private static _saveLastStatus(payload: Record<string, any>) {
    const globalTrackData = ClientUtils.getAppGlobal("trackings", {});
    globalTrackData.lastStatus = globalTrackData.lastStatus || {};
    let lastEvent = null;
    const pageType = payload.page_type;
    if (pageType) {
      globalTrackData.lastStatus.pageView = payload;
      if (pageType === "category") {
        const isPlp =
          payload.product_set || payload.page_type_section === "subcategory";
        globalTrackData.lastStatus.pageView.category_type = isPlp
          ? "PLP"
          : "Main Category";
      }
      lastEvent = "pageview";
    } else if (payload.event === "add_to_cart") {
      globalTrackData.lastStatus.cartInsertion = payload;
      lastEvent = "add_to_cart";
    }
    if (lastEvent) {
      window.dispatchEvent(new Event(`trackings.savedevent:${lastEvent}`));
    }
  }
}
